module.exports = __webpack_public_path__ + "img/720.4ad28ecb.png";